import { InjectedProperty } from "Global/Base/DIContainer";
import { GlobalContext } from "Global/Base/GlobalContext";
import { IErrorHandler } from "./IErrorHandler";

/**
 * Objekt sloužící pro přístup k singletonu IErrorHandler
 */
export class ErrorHandler {
    /** Instance singletonu */
    public static get instance(): IErrorHandler {
        return {} as any;
    }
}

InjectedProperty.bindProperty(ErrorHandler, "instance", IErrorHandler);
GlobalContext.registerType(ErrorHandler);
